








import { GET_LOADING } from '@/store/types';
import { Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageLoader extends Vue {
  @Getter(GET_LOADING)
  isLoading: boolean;
}
